<template>
  <div class="select">
    <!-- {{ selEduType }} {{ provinceList }}{{ cityList }}{{ districtList }}{{ villageList }} -->
    <!-- <el-cascader
      size="mini"
      ref="cascader"
      :props="propOptions"
      @change="handleChange"
      @expand-change="handleExpandChange"
      v-model="labelList"
      :placeholder="placeholderHTML"
      @visible-change="visible"
    >
    </el-cascader> -->

    <div class="list" v-if="provinceList.length > 0">
      <div class="label-name">省级：</div>
      <div>
        <span class="txt" :class="{active: selId == item.eduId}" v-for="item in provinceList" :key="item.eduId" @click="sel(item.eduId, item.eduType)">
          {{ item.eduName }}
        </span>
      </div>
    </div>
    <div class="list" v-if="cityList.length > 0">
      <div class="label-name">市级：</div>
      <div>
        <span class="txt" :class="{active: selId == item.eduId}" v-for="item in cityList" :key="item.eduId" @click="sel(item.eduId, item.eduType)">
          {{ item.eduName }}
        </span>
      </div>
    </div>
    <div class="list" v-if="districtList.length > 0">
      <div class="label-name">区/县级：</div>
      <div>
        <span class="txt" :class="{active: selId == item.eduId}" v-for="item in districtList" :key="item.eduId" @click="sel(item.eduId, item.eduType)">
          {{ item.eduName }}
        </span>
      </div>
    </div>
    <div class="list" v-if="villageList.length > 0">
      <div class="label-name">乡/镇级：</div>
      <div>
        <span class="txt" :class="{active: selId == item.eduId}" v-for="item in villageList" :key="item.eduId" @click="sel(item.eduId, item.eduType)">
          {{ item.eduName }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
let id = 0;
export default {
  name: "subOrganization",
  props: {
    // isEditSatus: {
    //   type: Boolean,
    //   default: {
    //     return: false
    //   }
    // },
    // addResize: {
    //   type: Number,
    //   default: {
    //     return: 0
    //   }
    // }
  },
  data() {
    return {
      selId: -1,
      selEduType: -1,
      eduBuresuType: this.$store.getters.getEduData.eduBuresuType,
      provinceList: [],
      cityList: [],
      districtList: [],
      villageList: [],

      propOptions:{
        lazy: true,
        lazyLoad : this.getList2
      },
      labelList:[this.$store.getters.getEduData.eduId],
      labelList_column:[],
      pathLabels:[],
      placeholderHTML:''
    };
  },
  created() {
    let eduId = this.$store.getters.getEduData.eduId;
    this.selEduType = this.$store.getters.getEduData.eduBuresuType;
    this.getList(eduId, 0, -1, 1);
  },
  mounted() {},
  watch: {
    addResize: {
      handler(newVal, oldVal) {
        // console.log(newVal)
        if (!this.isEditSatus) {
          // console.log(2222)
          this.eduId = "";
        }
      },
      immediate: true
    }
  },
  methods: {
    async getList2(node, resolve){
      console.log('getList2')
      const { level,value } = node;
      let reqData = {
        eduId: value?value:this.$store.getters.getEduData.eduId,
        eduType: level==0?0:1
      }
      let res = await this.$Http.getSubOrganization(reqData, false);
      if (res.code == 200) {
        const a = res.data.map(item =>({
          value: item.eduId,
          label: item.eduName,
          leaf: item.eduType>2
        }))

        this.pathLabels.push(...a);

      //   if(node.level != 0){
      //   if(node.level == 1){
      //   }
      // console.log('getList2',node,node.children,node.children.length,typeof(node.children))

      //   node.children.forEach(res =>{
      //     console.log(1)
      //     this.pathLabels.push(res)
      //   })
        console.log('pathLabels',this.pathLabels,new Set(this.pathLabels))
      // }
        resolve(a);
      }
    },
    handleChange(node){
      // console.log('handleChange',node,this.labelList)
      // this.labelList = node;
      this.labelList_column = node;
      this.$emit("getList", node[node.length-1]);
    },
    visible(boolean){
      // console.log(e)
      if(!boolean){
        this.labelList = this.labelList_column;
      }
    },
    handleExpandChange(node){
      this.labelList_column = node;


        let pathLabel = node.map(item => {
          let name
          this.pathLabels.forEach(res =>{
            if(res.value==item){
              name = res.label
            }
          })
          return name
        })
        // console.log('handleExpandChange',node,pathLabel)
      // if(node.pathLabels){
        // this.$refs['cascader'].clearCheckedNodes()
        this.placeholderHTML = pathLabel.join(' / ');
      // }
      // console.log(this.labelList,this.$refs['cascader'].getCheckedNodes(node))
      console.log('handleExpandChange',this.labelList)
      this.$emit("getList", node[node.length-1]);
      // if(this.labelList.length>=4){
      //   this.labelList = node;
      // }
    },
    
    sel(eduId, eduBuresuType) {
      this.selEduType = eduBuresuType;
      if(eduId == this.selId && eduId != this.$store.getters.getEduData.eduId) {
        return;
      } else {
        this.selId = eduId;
        switch (this.eduBuresuType){
          case 0:
            this.getList(eduId, 1);
            break;
          case 1:
            this.getList(eduId, 1);
            break;
          case 2:
            this.getList(eduId, 1);
            break;
          case 3:
            this.getList(eduId, 1);
            break;
          default:
            break;
        }        
      }
    },
    async getList(eduId = 0, eduType = 0, eduBuresuType, comeTime = 0) {
      let reqData = {};
      
      if (comeTime == 1) {
        reqData = {
          eduId: eduId,
          eduType: 0
        }
      } else {
        reqData = {
          eduId: eduId,
          eduType: 1
        }
      }
      // console.log(reqData)
      let res = await this.$Http.getSubOrganization(reqData, false);
      if (res.code == 200) {
        // console.log(res.data)
        // console.log(this.selEduType, "-------------")
        if (comeTime == 1) {
          switch (this.selEduType){
            case 0:
              this.provinceList = res.data;
              this.cityList = [];
              this.districtList = [];
              this.villageList = [];
              break;
            case 1:
              this.cityList = res.data;
              this.districtList = [];
              this.villageList = [];
              break;
            case 2:
              this.districtList = res.data;
              this.villageList = [];
              break;
            case 3:
              this.villageList = res.data;
              break;
            default:
              break;
          }
          this.sel(this.$store.getters.getEduData.eduId, this.$store.getters.getEduData.eduBuresuType)
        } else {
          switch (this.selEduType){
            case 0:
              this.cityList = res.data;
              this.districtList = [];
              this.villageList = [];
              break;
            case 1:
              // this.cityList = res.data;
              this.districtList = res.data;
              this.villageList = [];
              break;
            case 2:
              // this.districtList = res.data;
              this.villageList = res.data;
              break;
            case 3:
              // this.villageList = res.data;
              break;
            default:
              break;
          }
          this.$emit("getList", eduId || 0);
        }
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
  }
};
</script>
<style lang="scss">
.el-cascader{
  margin-right:5px;
  .el-input__inner{
    width:400px;
  }
  .el-input__inner::placeholder{
    color:#333;
  }
}
</style>
<style lang="scss" scoped>
.select {
  padding-top: 2px;
  background: #FFFFFF;
}
.list {
  margin: 2px 0;
  display: flex;
  justify-content: flex-start;
}
.label-name {
  flex: 0 0 86px;
  width: 86px;
  padding: 5px 0 8px 8px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #06162B;
  line-height: 20px;
}
.txt {
  margin-right: 16px;
  display: inline-block;
  padding: 5px 0px 5px 0px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #06162B;
  cursor: pointer;
  &.active {
    // margin-right: 10px;
    padding: 5px 6px 5px 6px;
    color: #FFFFFF;
    font-weight: 600;
    background: #007FFF;
    border-radius: 4px;
  }
}
</style>
